function formatQty(value: string): string {
  const normalized = value.trim().replace(/\s*(un|kg|g|ml|l|unidade)\s*$/i, "").trim();
  const n = parseFloat(normalized.replace(",", "."));
  if (Number.isNaN(n)) return value.trim();
  return Number.isInteger(n) ? String(n) : String(n);
}

/**
 * Normaliza mensagens de erro da API de vendas (estoque de produtos e insumos)
 * para exibição no toast do Caixa. Preserva o nome retornado pelo backend.
 */
export function formatVendaApiError(raw: string): string {
  const text = raw.trim();
  if (!text) return "Erro ao finalizar venda";

  // Produto com quantidades: Disponível / solicitado
  const produtoComQty = text.match(
    /Estoque insuficiente para o produto ["“]?([^"”]+)["”]?\.?\s*Dispon[ií]vel:\s*([\d.,]+)\s*,\s*solicitado:\s*([\d.,]+)/i,
  );
  if (produtoComQty) {
    const [, produto, disponivel, solicitado] = produtoComQty;
    return `Estoque insuficiente para o produto ${produto.trim()}. Disponível: ${formatQty(disponivel)}, necessário: ${formatQty(solicitado)}.`;
  }

  // Promo / produto: necessário X un, disponível Y
  const produtoPromo = text.match(
    /estoque insuficiente\.?\s*Produto ["“]?([^"”]+)["”]?\s*necess[aá]rio:\s*([\d.,]+)\s*un,?\s*dispon[ií]vel:\s*([\d.,]+)/i,
  );
  if (produtoPromo) {
    const [, produto, necessario, disponivel] = produtoPromo;
    return `Estoque insuficiente para o produto ${produto.trim()}. Disponível: ${formatQty(disponivel)}, necessário: ${formatQty(necessario)}.`;
  }

  // Produto só com nome
  const produtoNome = text.match(/Estoque insuficiente para o produto ["“]?([^"”.]+)["”]?/i);
  if (produtoNome && /estoque insuficiente/i.test(text) && /produto/i.test(text) && !/insumo/i.test(text)) {
    return `Estoque insuficiente para o produto ${produtoNome[1].trim()}.`;
  }

  // Insumo com Necessário / disponível
  const insumoPadrao = text.match(
    /Estoque insuficiente do insumo ["“]?([^"”]+)["”]?(?: para o produto ["“]?[^"”]+["”]?)?\.?\s*Necess[aá]rio:\s*([\d.,]+(?:\s*\w+)?)\s*,\s*dispon[ií]vel:\s*([\d.,]+)/i,
  );
  if (insumoPadrao) {
    const [, insumo, necessario, disponivel] = insumoPadrao;
    return `Estoque insuficiente para o insumo ${insumo.trim()}. Disponível: ${formatQty(disponivel)}, necessário: ${formatQty(necessario)}.`;
  }

  // Insumo promo: (necessário: X, disponível: Y)
  const insumoPromo = text.match(
    /estoque insuficiente do insumo ["“]?([^"”]+)["”]?\s*\(necess[aá]rio:\s*([\d.,]+(?:\s*\w+)?)\s*,\s*dispon[ií]vel:\s*([\d.,]+)\)/i,
  );
  if (insumoPromo) {
    const [, insumo, necessario, disponivel] = insumoPromo;
    return `Estoque insuficiente para o insumo ${insumo.trim()}. Disponível: ${formatQty(disponivel)}, necessário: ${formatQty(necessario)}.`;
  }

  // Insumo só com nome
  const insumoNome = text.match(
    /estoque insuficiente(?: do| para o)? insumo ["“]?([^"”.(]+)["”]?/i,
  );
  if (insumoNome) {
    return `Estoque insuficiente para o insumo ${insumoNome[1].trim()}.`;
  }

  // Backend já trouxe mensagem útil — não substituir por genérica.
  return text;
}
